import {
  prepareAndMakeRequest,
  type Notification,
  type NotificationListResponse,
} from '@frontend/api';

/** Integer primary key; DRF's IntegerField also accepts numeric strings */
type EntityId = number | string;

/** 204 No Content (and other empty bodies) come back as `''` from `getPayload` */
type EmptyResponseBody = '';

const chat = {
  acknowledgeChannelNotifications: (
    channelId: EntityId,
  ): Promise<EmptyResponseBody> =>
    prepareAndMakeRequest.put<EmptyResponseBody>(
      `/notifications/chat/acknowledge_channel/${channelId}`,
    ),
  acknowledgeThreadNotifications: (
    annotationId: EntityId,
  ): Promise<EmptyResponseBody> =>
    prepareAndMakeRequest.put<EmptyResponseBody>(
      `/notifications/chat/acknowledge_thread/${annotationId}`,
    ),
};

export default {
  chat,
  list: (params: {
    page?: number;
    filterOutAcknowledged?: boolean;
  }): Promise<NotificationListResponse> =>
    prepareAndMakeRequest.get<NotificationListResponse>('/notifications', {
      query: params,
    }),
  patch: (
    notificationId: EntityId,
    data: { isAcknowledged?: boolean },
  ): Promise<Notification> =>
    prepareAndMakeRequest.patch<Notification>(
      `/notifications/${notificationId}`,
      { body: data },
    ),
  /** Responds with the remaining unacknowledged notifications */
  markAllRead: (): Promise<Notification[]> =>
    prepareAndMakeRequest.patch<Notification[]>('/notifications/read'),
  /** PNG, or empty while the thumbnail is processing (202) or missing (204) */
  getThumbnail: (partFileUuid: string): Promise<Blob | EmptyResponseBody> =>
    prepareAndMakeRequest.get<Blob | EmptyResponseBody>(
      `/parts/files/${partFileUuid}/thumbnail/`,
    ),
};
